import { render, staticRenderFns } from "./MentionsLegalesView.vue?vue&type=template&id=2eabaa73&scoped=true"
import script from "./MentionsLegalesView.vue?vue&type=script&lang=js"
export * from "./MentionsLegalesView.vue?vue&type=script&lang=js"
import style0 from "./MentionsLegalesView.vue?vue&type=style&index=0&id=2eabaa73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eabaa73",
  null
  
)

export default component.exports